import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import CircularLoader from '@base/CircularLoader/CircularLoader';

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: span 24;
  margin: ${({ $margin }) => $margin};
`;

const Loader = ({ margin }) => (
  <LoaderContainer $margin={margin}>
    <CircularLoader size={30} color="var(--color-i-blue)" />
  </LoaderContainer>
);

export default Loader;

Loader.propTypes = {
  margin: PropTypes.string
};

Loader.defaultProps = {
  margin: '20% 0px'
};
